import { render, staticRenderFns } from "./DesignationCreate.vue?vue&type=template&id=0c1d5e18"
import script from "./DesignationCreate.vue?vue&type=script&lang=js"
export * from "./DesignationCreate.vue?vue&type=script&lang=js"
import style0 from "./DesignationCreate.vue?vue&type=style&index=0&id=0c1d5e18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports